import { useEffect, useState } from 'react'
import { LayoutTitle, LayoutView, TitleText } from '../../../component/layout/layoutMainStyle'
import ButtonCustom from '../../../component/button/buttonCustom'
import { icons } from '../../../constants/images'
import { Box, Grid, Typography } from '@mui/material'
import InputTextField from '../../../component/input/inputTextField'
import RoleApi from '../../../api/role/role.api'
import { useLocation } from 'react-router-dom'
import { swalError, swalSuccess } from '../../../component/notification/swal'
import { Permission } from '../../../constants/permission'
import { useTranslation } from 'react-i18next'
import CheckboxPermission from '../../../component/checkboxPermission/checkboxPermission'

const initStateErrorMessage = {
    ROLE: "",
};
interface Action {
    name: string;
    code: string;
    permit: boolean;
    actions: Action[];
}

interface Role {
    name: string;
    code: string;
    permit: boolean;
    actions: Action[];
}

export default function DetailRole() {
    const { t } = useTranslation();
    const location = useLocation()
    const idRole = location.state?.idRole || ''
    const [input, setInput] = useState<any>({
        roleName: '',
        roleStatus: 'เปิดใช้งาน'
    })
    const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage);
    const clearErrorMessage = () => setErrorMessage(initStateErrorMessage);
    const [permission, setPermission] = useState<Role[]>(Permission);
    const [loading, setLoading] = useState<boolean>(false);

    ///// function checkbox /////////////

    const handleCheckboxChange = (node: any, checked: boolean) => {
        const updatedData = updateData([...permission], node, checked);
        setPermission(updatedData);
    };
    const updatePermit = (data: any, checked: boolean) => {
        return data.map((item: any) => {
            const updatedItem = { ...item, permit: checked };
            if (item.actions && item.actions.length > 0) {
                updatedItem.actions = updatePermit(item.actions, checked);
            }
            return updatedItem;
        });
    };
    const updateData = (arr: any, targetNode: any, checked: boolean) => {
        return arr.map((node: any) => {
            if (node.code === targetNode.code) {
                return { ...node, permit: checked, actions: checked ? targetNode.actions : updatePermit(node.actions, false) };
            } else if (node.actions && node.actions.length > 0) {
                return { ...node, actions: updateData(node.actions, targetNode, checked) };

            }
            return node;
        });
    };

    const updateAll = (data: any) => {
        setPermission(updatePermit(data, true))
    }
    ////////////////////////////////////////

    const loadData = async () => {
        if (idRole) {
            RoleApi.getRole({ idRole: idRole }).then((res) => {
                if (res?.data?.success) {
                    setInput(res.data.result);
                    setPermission(res.data.result.permission)
                }
            });
        }

    }
    useEffect(() => {
        loadData()
    }, [])

    const postData = async () => {

        if (!input.roleName)
            return setErrorMessage({
                ...errorMessage,
                ...{ ROLE: t('EMPLOYEES_CREATE.MESSAGE.ROLE') },
            });
        setLoading(true)
        const body = {
            ...input,
            permission: permission
        }
        if (input?.idRole) {
            await RoleApi.patchRole(input?.idRole, body).then((res) => {
                if (res?.data?.success) {
                    loadData()
                    swalSuccess(t('EMPLOYEES_CREATE.SWAL.EDIT_SUCCESS'))
                } else {
                    setLoading(false)
                    swalError(res.data.description || res.data.message);
                }

            }).catch((error: any) => {
                setLoading(false)
                swalError(error.response.data.description || error.response.data.message);
            })
        } else {
            await RoleApi.postRole(body).then((res) => {
                if (res?.data?.success) {
                    loadData()
                    swalSuccess(t('EMPLOYEES_CREATE.SWAL.CREATE_SUCCESS'))
                } else {
                    setLoading(false)
                    swalError(res.data.description || res.data.message);
                }

            }).catch((error: any) => {
                setLoading(false)
                swalError(error.response.data.description || error.response.data.message);
            })
        }

    }
    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>{t('ROLE_CREATE.TITLE')}</TitleText>
                <ButtonCustom disabled={loading} textButton={t('ROLE_CREATE.BUTTON.SUBMMIT')} onClick={() => postData()} />

            </LayoutTitle>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <InputTextField heading={t('ROLE_CREATE.INPUT.ROLE')} value={input.roleName} onchange={(event: any) => {
                        setInput({ ...input, roleName: event.target.value })
                        clearErrorMessage();
                    }}
                        helperText={
                            errorMessage.ROLE || ''
                        } />
                </Grid>
               
            </Grid>
            <Typography variant='h6' sx={{ margin: "22px 0px", fontWeight: '500' }}>{t('ROLE_CREATE.PERMISSION')}</Typography>
            <ButtonCustom textButton={t('ROLE_CREATE.BUTTON.SELETE_ALL')} onClick={() => updateAll(permission)} />
            <Box sx={{
                margin: '20px 0',
            }}>
                {
                    permission.map((node) => (
                        <CheckboxPermission
                            key={node.name}
                            node={node}
                            onCheckboxChange={handleCheckboxChange}
                        />
                    ))
                }
            </Box>
        </LayoutView >
    )
}
